import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';
import { Box, Typography, Grid, Paper } from '@mui/material';

const SportsPhysiotherapy = () => {
  const serviceData = {
    title: "Sports Physiotherapy",
    image: "/sports.png", // Make sure this matches your image path in public folder
    description: "Our sports physiotherapy service specializes in treating athletes and active individuals. We focus on injury prevention, performance enhancement, and quick recovery from sports-related injuries.",
    benefits: [
      "Sports injury assessment and treatment",
      "Performance enhancement programs",
      "Pre-competition conditioning",
      "Post-injury rehabilitation",
      "Sports-specific training",
      "Injury prevention strategies"
    ],
    approach: [
      "Comprehensive biomechanical assessment",
      "Sport-specific rehabilitation protocols",
      "Advanced therapeutic techniques",
      "Performance optimization training",
      "Injury prevention strategies",
      "Return-to-sport testing"
    ],
    additionalContent: (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Specialized Programs
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: "Pre-Competition Preparation",
              description: "Tailored programs to ensure peak performance and minimize injury risk before competitions."
            },
            {
              title: "Post-Injury Recovery",
              description: "Comprehensive rehabilitation programs to safely return athletes to their sport."
            },
            {
              title: "Performance Enhancement",
              description: "Advanced techniques and training to improve athletic performance and capabilities."
            }
          ].map((program, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,150,136,0.15)'
                  }
                }}
              >
                <Typography variant="h6" gutterBottom color="primary">
                  {program.title}
                </Typography>
                <Typography variant="body2">
                  {program.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  };

  return <ServiceLayout {...serviceData} />;
};

export default SportsPhysiotherapy; 